"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacingTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const spacingNone = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-none',
    fallback: '0px'
});
const spacingXXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-xxs',
    fallback: '2px'
});
const spacingXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-xs',
    fallback: '4px'
});
const spacingS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-s',
    fallback: '8px'
});
const spacingSM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-sm',
    fallback: '12px'
});
const spacingM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-m',
    fallback: '16px'
});
const spacingL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-l',
    fallback: '24px'
});
const spacingXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-xl',
    fallback: '32px'
});
const spacingXXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-xxl',
    fallback: '48px'
});
const spacingXXXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'spacing-xxxl',
    fallback: '64px'
});
exports.spacingTokens = {
    spacingNone,
    spacingXXS,
    spacingXS,
    spacingS,
    spacingSM,
    spacingM,
    spacingL,
    spacingXL,
    spacingXXXL,
    spacingXXL
};
//# sourceMappingURL=Spacing.js.map